module.exports = __webpack_public_path__ + "img/development-during-recession-top.e284f4d7.jpeg";